import { NgModule } from '@angular/core';
import { Observable } from 'rxjs';
import { MatDialogModule } from '@angular/material/dialog';
import { FilterModule } from '@vendasta/va-filter2';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { PipelineBoardFilterChipsComponent } from './pipeline-board-filter-chips/pipeline-board-filter-chips.component';
import { FilterChipsModule } from '../../../filters/filter-chips/filter-chips.module';
import { MatMenuModule } from '@angular/material/menu';
import {
  PIPELINE_BOARD_FILTER_CHIPS_CONFIG_TOKEN,
  PipelineBoardFilterChipsConfig,
} from './pipeline-board-filter-chips/tokens';
import {
  HAS_ACCESS_TO_ALL_ACCOUNTS_IN_MARKET_TOKEN,
  SALES_TEAM_SERVICE_TOKEN,
  SalesTeamServiceInterface,
} from '../../tokens';
import { PipelineBoardFilteredComponent } from './pipeline-board-filtered.component';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { PipelineSavedFiltersModule } from '../../pipeline-saved-filters/pipeline-saved-filters.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EmptyStateModule, VaBadgeModule } from '@vendasta/uikit';
import { PreferredCurrencyModule } from '@vendasta/sales-common';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { StageComponent } from '../../pipeline-board-stage/stage.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { PipelineCardModule } from '../../pipeline-card/pipeline-card.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PIPELINE_CARD_CONFIG_TOKEN, PipelineCardConfig } from '../../pipeline-card/tokens';
import { MatDivider } from '@angular/material/divider';

@NgModule({
  declarations: [PipelineBoardFilterChipsComponent, PipelineBoardFilteredComponent, StageComponent],
  exports: [PipelineBoardFilterChipsComponent, PipelineBoardFilteredComponent, StageComponent],
  providers: [
    {
      provide: HAS_ACCESS_TO_ALL_ACCOUNTS_IN_MARKET_TOKEN,
      deps: [PIPELINE_BOARD_FILTER_CHIPS_CONFIG_TOKEN],
      useFactory: hasAccessToAllAccountsInMarketFactory,
    },
    {
      provide: SALES_TEAM_SERVICE_TOKEN,
      deps: [PIPELINE_BOARD_FILTER_CHIPS_CONFIG_TOKEN],
      useFactory: salesTeamsServiceFactory,
    },
    {
      provide: PIPELINE_CARD_CONFIG_TOKEN,
      deps: [PIPELINE_BOARD_FILTER_CHIPS_CONFIG_TOKEN],
      useFactory: pipelineCardConfigFactory,
    },
  ],
  imports: [
    CommonModule,
    FilterChipsModule,
    FilterModule,
    MatDialogModule,
    TranslateModule,
    MatMenuModule,
    GalaxyPageModule,
    MatInputModule,
    MatIconModule,
    PipelineSavedFiltersModule,
    MatTooltipModule,
    VaBadgeModule,
    PreferredCurrencyModule,
    EmptyStateModule,
    DragDropModule,
    MatButtonModule,
    MatFormFieldModule,
    PipelineCardModule,
    MatProgressSpinnerModule,
    MatDivider,
  ],
})
export class PipelineBoardFiltersModule {}

function hasAccessToAllAccountsInMarketFactory(config: PipelineBoardFilterChipsConfig): Observable<boolean> {
  return config.hasAccessToAllAccountsInMarket$;
}

function salesTeamsServiceFactory(config: PipelineBoardFilterChipsConfig): SalesTeamServiceInterface {
  return config.salesTeamsService;
}

function pipelineCardConfigFactory(config: PipelineBoardFilterChipsConfig): PipelineCardConfig {
  return {
    allSalespeople$: config.allSalespeople$,
    defaultCurrency$: config.defaultCurrency$,
    opportunityInfoUrlBuilder: config.opportunityInfoUrlBuilder,
    detailsConfig: config.detailsConfig,
  };
}
